import { IsArray, IsUUID } from 'class-validator';

export class ConvertEventsToPaperDto {
  @IsUUID(undefined, { each: true })
  @IsArray()
  eventIds: string[];
}
